import { Modal } from 'antd';
import React from 'react';
import { ASSET_CATEGORY, ASSET_TYPE } from '../../../common/constants';
import CommonAudioForm from '../audio/CommonAudioForm';
import CommonDocumentForm from '../document/CommonDocumentForm';
import CommonIconForm from '../icons/CommonIconForm';
import CommonImageForm from '../images/CommonImageForm';
import CommonVideoForm from '../videos/CommonVideoForm';

const CreateAssetModal = ({
  showModal,
  setShowModal,
  assetType,
  title = `Create ${ASSET_TYPE[assetType] ?? 'Asset'}`,
  setNewAsset
}) => {
  const handleCancel = () => {
    setShowModal(false);
  };
  const renderForms = () => {
    if (assetType === ASSET_CATEGORY.IMAGE) {
      return (
        <CommonImageForm
          isModal
          setShowModal={setShowModal}
          setNewAsset={setNewAsset}
        />
      );
    }
    if (assetType === ASSET_CATEGORY.VIDEO) {
      return (
        <CommonVideoForm
          isModal
          setShowModal={setShowModal}
          setNewAsset={setNewAsset}
        />
      );
    }
    if (assetType === ASSET_CATEGORY.DOCUMENT) {
      return (
        <CommonDocumentForm
          isModal
          setShowModal={setShowModal}
          setNewAsset={setNewAsset}
        />
      );
    }
    if (assetType === ASSET_CATEGORY.AUDIO) {
      return (
        <CommonAudioForm
          isModal
          setShowModal={setShowModal}
          setNewAsset={setNewAsset}
        />
      );
    }
    // NOTE: Commented out for CVP 7.2 fixes - BBART-2082
    // See: https://app.clickup.com/t/606124/BBART-2082
    // if (assetType === ASSET_CATEGORY.TEXT) {
    //   return (
    //     <CommonTextForm
    //       isModal
    //       setShowModal={setShowModal}
    //       setNewAsset={setNewAsset}
    //     />
    //   );
    // }
    if (assetType === ASSET_CATEGORY.ICON) {
      return (
        <CommonIconForm
          isModal
          setShowModal={setShowModal}
          setNewAsset={setNewAsset}
        />
      );
    }
  };

  return (
    <Modal
      centered
      open={showModal}
      onCancel={handleCancel}
      footer={null}
      destroyOnClose
      title={title}
      width="60%"
    >
      <div>{renderForms()}</div>
    </Modal>
  );
};

export default CreateAssetModal;
